import { render, staticRenderFns } from "./ChangeUserSettings.vue?vue&type=template&id=8d7c88ac&scoped=true"
import script from "./ChangeUserSettings.vue?vue&type=script&lang=js"
export * from "./ChangeUserSettings.vue?vue&type=script&lang=js"
import style0 from "./ChangeUserSettings.vue?vue&type=style&index=0&id=8d7c88ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7c88ac",
  null
  
)

export default component.exports